// @ts-nocheck
import {
    addToChainAfter,
    ExtractHandlerParameter,
    ExtractHandlerProps,
} from "@toolkit/Modules/client-framework/HandlerCreator";
import { SetUserFields, chain } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";

type HandlerChainType = typeof SetUserFields;

export interface SetUserFieldsParameters extends ExtractHandlerParameter<HandlerChainType> {
    properties?: { [key: string]: string };
}

export interface SetUserFieldsProps extends ExtractHandlerProps<HandlerChainType> {}

addToChainAfter<SetUserFieldsParameters, SetUserFieldsProps>(chain, SetUserFields, props => {
    const { parameter, result } = props;

    if (result.updatedUser && parameter.properties) {
        result.updatedUser.properties = {
            ...(result.updatedUser.properties || {}),
            ...parameter.properties,
        };
    }
});
